document.addEventListener('DOMContentLoaded', function () {
  if (typeof Countdown === 'undefined') {
    class Countdown extends HTMLElement {
      constructor() {
        super();

        this._selectors = {
          countdown: {
            showDays: '[js-countdown-showDays]',
            hours: '[js-countdown-hours]',
            minutes: '[js-countdown-minutes]',
            seconds: '[js-countdown-seconds]'
          },
          stages: {
            default: '[js-stage-default]',
            complete: '[js-stage-complete]'
          }
        };

        this.stages = {
          default: this.querySelectorAll(this._selectors.stages.default),
          complete: this.querySelectorAll(this._selectors.stages.complete)
        };

        this.countdown = {
          showDays: this.querySelector(this._selectors.countdown.showDays),
          hours: this.querySelector(this._selectors.countdown.hours) || null,  // Safe fallback
          minutes: this.querySelector(this._selectors.countdown.minutes) || null,  // Safe fallback
          seconds: this.querySelector(this._selectors.countdown.seconds) || null  // Safe fallback
        };
      }

      connectedCallback() {
        const targetDate = this.getAttribute('data-targetdate');
        this._initCountdown(targetDate);
        this._displayCountdown();
      }

      _setStage(stage) {
        if (stage === 'complete') {
          this.stages.complete.forEach((item) => item.classList.remove('hidden'));
          this.stages.default.forEach((item) => item.classList.add('hidden'));

          if (this.getAttribute('data-hide-on-complete') === 'true') {
            this.classList.add('hidden');
          }
        } else if (stage === 'default') {
          this.stages.default.forEach((item) => item.classList.remove('hidden'));
          this.stages.complete.forEach((item) => item.classList.add('hidden'));
        }
      }

      _displayCountdown() {
        this.classList.remove('opacity-0');
        this.classList.add('opacity-100');
      }

      _initCountdown(targetDate) {
        const deadline = new Date(targetDate).getTime();

        const formatTime = (time) => String(time).padStart(2, '0');

        const interval = setInterval(() => {
          const now = new Date().getTime();
          const t = deadline - now;

          if (t <= 0) {
            // Check if countdown elements exist before setting innerHTML
            if (this.countdown.hours && this.countdown.minutes && this.countdown.seconds) {
              this.countdown.hours.innerHTML = formatTime(0);
              this.countdown.minutes.innerHTML = formatTime(0);
              this.countdown.seconds.innerHTML = formatTime(0);
            }
            clearInterval(interval);
            this._setStage('complete');
            return;
          }

          const days = Math.floor(t / (1000 * 60 * 60 * 24));
          const hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((t % (1000 * 60)) / 1000);

          if (days > 0) {
            if (!this.countdown.daysElement) {
              this.countdown.daysElement = document.createElement('p');
              this.countdown.daysElement.className = 'countdown-widget__container';
              this.countdown.daysElement.style.display = 'flex';
              this.countdown.daysElement.innerHTML = `<span class="countdown-number" js-countdown-days>${formatTime(days)}</span> Days`;

              // Use insertAdjacentHTML to insert the colon with the timer-colon class
              this.countdown.showDays.insertAdjacentElement('afterend', this.countdown.daysElement);
              this.countdown.daysElement.insertAdjacentHTML('afterend', ' <span class="timer-colon">:</span> ');

              this.countdown.showDays.setAttribute('data-show', 'true');
            } else {
              this.countdown.daysElement.querySelector('[js-countdown-days]').innerHTML = formatTime(days);
              this.countdown.daysElement.style.display = 'flex';
              this.countdown.daysElement.nextSibling.outerHTML = ' <span class="timer-colon">:</span> ';
            }
          } else {
            if (this.countdown.daysElement) {
              this.countdown.daysElement.style.display = 'none';
              if (this.countdown.daysElement.nextSibling) {
                this.countdown.daysElement.nextSibling.remove();
              }
              this.countdown.showDays.setAttribute('data-show', 'false');
            }
          }

          // Safely update the countdown elements if they exist
          if (this.countdown.hours && this.countdown.minutes && this.countdown.seconds) {
            this.countdown.hours.innerHTML = formatTime(hours);
            this.countdown.minutes.innerHTML = formatTime(minutes);
            this.countdown.seconds.innerHTML = formatTime(seconds);
          }

          this._setStage('default');
        }, 1000);
      }
    }

    if (!customElements.get('s-countdown')) {
      customElements.define('s-countdown', Countdown);
    }
  }
});
